<script setup lang="ts">
import Tooltip from '@jaaluu/components/Tooltip.vue';
import stores from '@jaaluu/stores';
import vuetify from '@jaaluu/vuetify';

const { removeTooltip } = stores.tooltip.funcs;

const { tooltips } = stores.tooltip.state;
</script>

<template>
  <v-dialog
    v-for="(tooltip, idx) in tooltips"
    v-model="tooltip.open"
    :min-width="vuetify.display.smAndUp.value ? 500 : 300"
    :fullscreen="vuetify.display.smAndDown.value"
    class="tooltip-wrapper"
    @close="() => removeTooltip(idx)"
  >
    <Tooltip :tooltip="tooltip" />
  </v-dialog>
</template>

<style></style>
